<template>
	<div class="row">
		<div class="col-md-6">
			<fieldset>
				<div class="form-group">
					<label>{{ $t('name') }}</label>
					<input type="text" class="form-control" v-model="formelement.name" :placeholder="$t('name')">
				</div>
				<div class="form-group">
					<label>{{ $t('caption') }}</label>
					<input type="text" class="form-control" v-model="formelement.caption" :placeholder="$t('caption')">
				</div>
				<div class="form-group">
					<label>{{ $t('type') }}</label>
					<select class="form-control" v-model="formelement.formelementtype_id" @change="setTypeDefaults">
						<option value=""></option>
						<option v-for="(fcaption, fkey) in fieldtypes" :key="fkey" :value="fkey">{{$t(fcaption)}}</option>
					</select>
				</div>
				<div v-if="formelement.formelementtype_id==6 || formelement.formelementtype_id==7" class="form-group">
					<label>{{ $t('options') }}</label>
					<div v-for="(option, oindex) in formelement.options" :key="oindex" class="row mb-2">
						<div class="col-md-4">
							<input class="form-control" type="text" v-model="option.Value" :placeholder="$t('value')">
						</div>
						<div class="col-md-4">
							<input class="form-control" type="text" v-model="option.Caption" :placeholder="$t('caption')">
						</div>
						<div class="col-md-4">
							<button type="button" class="btn btn-danger" @click="removeOption(option)"><b-icon icon="trash" width="1em" height="1em"></b-icon> {{ $t('remove') }}</button>
						</div>
					</div>
					<button type="button" class="btn btn-light" @click="formelement.options.push({Value:'', Caption:[]})">+ {{$t('add-option')}}</button>
				</div>
				<div class="form-group" v-if="formelement.formelementtype_id==13">
					<label>{{ $t('max-value') }}</label>
					<input type="number" class="form-control" v-model="formelement.attributes.max" :placeholder="$t('100')">
				</div>
				<div class="form-group" v-if="formelement.formelementtype_id==13">
					<label>{{ $t('multiplier-group-caption') }}</label>
					<input type="text" class="form-control" v-model="formelement.attributes.multicaption" :placeholder="$t('multiplier-group-caption')">
				</div>
				<div class="form-group">
					<label>{{ $t('default-value') }}</label>
					<select v-if="formelement.formelementtype_id==2" class="form-control" v-model="formelement.default">
						<option value="0">{{$t('false')}}</option>
						<option value="1">{{$t('true')}}</option>
					</select>
					<select v-else-if="formelement.formelementtype_id==6" class="form-control" v-model="formelement.default">
						<option value=""></option>
						<option v-for="(option, oindex) in formelement.options" :key="oindex" :value="option.Value">{{option.Caption}}</option>
					</select>
					<input type="text" v-else class="form-control" v-model="formelement.default">
				</div>

				<div class="form-group">
					<label>{{ $t('dependencies') }}</label>
					<textarea style="height: 200px;" v-model="formelement.dependencies" class="form-control"></textarea>
				</div>

			</fieldset>
		</div>
		<div class="col-md-6">
			<template v-if="(formelement.id in reporting.formelements) && reporting.formelements[formelement.id] && reporting.formelements[formelement.id].length > 0">
				<h2>{{ $t('reported-in') }}</h2>
				<div class="list-group no-border border">
					<div v-for="(item, rfindex) in reporting.formelements[formelement.id]" :key="formelement.id + '-' + rfindex" class="list-group-item p-0">
						<router-link v-if="('reportdataelement_id' in item && item['reportdataelement_id'])" :to="'/settings/reports/dataelements/edit/' +item.reportdataelement_id" class="list-group-item">
							{{item.caption}}
							({{item.name}})
						</router-link>
						<div v-else class="list-group-item">
							{{item.caption}}
							({{item.name}})
						</div>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	components: {
	},
	props: [
		'formelement',
		'fieldtypes',
		'reporting'
	],
	data() {
		return {}
	},
	mounted() {
		this.setTypeDefaults();
	},
	methods: {
		removeOption: function(option){
			var self = this;
			this.$store.commit("openDialog", {
				cancelBtn: true,
				title: this.$t("remove-option-q"),
				content: this.$t('remove-option-{n}q', {'n': option.Caption}),
				confirmBtnText: this.$t('yes'),
				cancelBtnText: this.$t('no'),
				confirmCallBack() {
					self.formelement.options.splice(self.formelement.options.indexOf(option), 1);
				},
				cancelCallBack() {
				}
			});
		},
		setTypeDefaults: function(){
			if(this.formelement.formelementtype_id==13){
				//alert('here');
				if(!('attributes' in this.formelement) || !this.formelement.attributes){
					this.formelement = Object.assign({}, this.formelement, {
						attributes: {
							max: 12 ,
							multicaption: ''
						}
					});
				}
				if(!('max' in this.formelement.attributes)){
					this.formelement.attributes = Object.assign({}, this.formelement.attributes, {
						max: 12
					});
				}
				if(!('multicaption' in this.formelement.attributes)){
					this.formelement.attributes = Object.assign({}, this.formelement.attributes, {
						multicaption: ''
					});
				}
			}
		}
	},
	computed: {

	}
};
</script>
